import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { BrowserModule } from "@angular/platform-browser";
import { SharedModule } from "src/app/shared/shared.module";
import { ProgramasPermitidosPorCestasListagemComponent } from "./listagem/programas-permitidos-por-cestas-listagem.component";
import { ProgramasPermitidosPorCestasPesquisaComponent } from "./pesquisa/programas-permitidos-por-cestas-pesquisa.component";
import { ProgramasPermitidosPorCestasEdicaoComponent } from "./edicao/programas-permitidos-por-cestas-edicao.component";
import { ProgramasPermitidosPorCestasRoutingModule } from "./programas-permitidos-por-cestas-routing.module";
import { NgSelectModule } from "@ng-select/ng-select";
import { HabilitacaoProgramaComponent } from './habilitacao-programa/habilitacao-programa.component';

@NgModule({
  imports: [
    SharedModule,
    BrowserModule,
    CommonModule,
    FormsModule,
    ProgramasPermitidosPorCestasRoutingModule,
    NgSelectModule,
  ],
  exports: [],
  declarations: [
    ProgramasPermitidosPorCestasListagemComponent,
    ProgramasPermitidosPorCestasPesquisaComponent,
    ProgramasPermitidosPorCestasEdicaoComponent,
    HabilitacaoProgramaComponent,
  ],
  providers: [],
  schemas: [],
})
export class ProgramasPermitidosPorCestasModule {}
